// @flow

import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { type Match, withRouter } from "react-router";

import { load as loadOption } from "../../redux/modules/option";
import { type State as OptionsState } from "../../redux/modules/options.d";
import { type State as CategoriesState } from "../../redux/modules/categories.d";
import {
    load as loadOptions,
    clear as clearOptions,
} from "../../redux/modules/options";
import { load as loadCategories } from "../../redux/modules/categories";
import { type State as ConfirmOptionsState } from "../../redux/modules/confirm-options.d";
import {
    load as confirmOptions,
    clear as clearConfirmOption,
    ERROR as CONFIRM_OPTIONS_ERROR,
} from "../../redux/modules/confirm-options";
import { load as loadSeries } from "../../redux/modules/series";
import { load as loadEventSeries } from "../../redux/modules/event-series";
import { refetch as reloadCalendar } from "../../redux/modules/calendar";
import { withTranslate } from "../Translate";
import ConfirmOptions from "../../components/Events/ConfirmOptions";
import { mapState } from "../../redux/utils";

type Props = {
    type: "OPTION" | "SERIES",
    onClose: () => void,
    translate: *,
    /** option */
    options: OptionsState,
    categories: CategoriesState,
    series: *,
    loadOption: (uuid: string) => *,
    loadOptions: (uuid: string) => *,
    loadCategories: () => *,
    loadEventSeries: (uuid: string) => *,
    loadSeries: (filter: string) => *,
    clearOptions: () => void,
    /** confirm options */
    confirmOptions: (options: Object[]) => *,
    clearConfirmOption: *,
    confirmOptionsState: ConfirmOptionsState,
    /** event series */
    eventSeries: *,
    /** calendar */
    reloadCalendar: *,
    /** match */
    match: Match,
};

class ConfirmOptionsContainer extends Component<Props> {
    componentDidMount() {
        const { loadOptions, loadCategories, loadEventSeries, loadSeries } =
            this.props;
        this.clear();
        loadOptions(this.uuid).then(result => {
            const filter =
                result?.payload?.seriesName ||
                result?.payload?.seriesOptionCode ||
                "";
            if (filter) loadSeries(filter);
        });
        loadCategories();
        loadEventSeries(this.uuid);
    }

    clear() {
        const { clearConfirmOption, clearOptions } = this.props;
        clearConfirmOption();
        clearOptions();
    }

    get uuid() {
        const { match } = this.props;
        return match.params.uuid ? match.params.uuid.toString() : "";
    }

    render() {
        const {
            translate,
            options,
            categories,
            onClose,
            type,
            confirmOptions,
            clearConfirmOption,
            reloadCalendar,
            confirmOptionsState,
            eventSeries,
            series,
        } = this.props;

        const initialCategoryUuid = eventSeries?.data?.categoryUuid;
        const isCategoryRequired = series.data?.content?.some(item =>
            [
                "PUBLIC",
                "LIMITED_AVAILABILITY",
                "OPTION_CONFIRMED",
                "PRIVATE",
            ].includes(item.status),
        );

        return (
            <ConfirmOptions
                onClose={onClose}
                translate={translate}
                onSubmit={(options, categoryUuid) =>
                    confirmOptions(options, categoryUuid).then(() => {
                        reloadCalendar();
                        onClose();
                        clearConfirmOption();
                    })
                }
                options={options.data}
                confirmOptionsState={confirmOptionsState}
                categories={categories.data?.content}
                type={type}
                loading={options.loading}
                initialCategoryUuid={initialCategoryUuid}
                isCategoryRequired={isCategoryRequired}
            />
        );
    }
}

export default withTranslate(
    withRouter(
        connect(
            // Map state to props
            ({ options, categories, confirmOptions, eventSeries, series }) => ({
                options,
                categories,
                eventSeries,
                series,
                confirmOptionsState: mapState(
                    confirmOptions,
                    CONFIRM_OPTIONS_ERROR,
                ),
            }),
            // Map dispatch to props
            (dispatch: *) =>
                bindActionCreators(
                    {
                        loadOption: uuid => loadOption(uuid),
                        loadOptions: uuid => loadOptions(uuid),
                        loadCategories,
                        loadEventSeries: uuid => loadEventSeries(uuid),
                        loadSeries: filter => loadSeries(filter),
                        confirmOptions: (options, categoryUuid) =>
                            confirmOptions(options, categoryUuid),
                        reloadCalendar: () => reloadCalendar(),
                        clearConfirmOption,
                        clearOptions,
                    },
                    dispatch,
                ),
        )(ConfirmOptionsContainer),
    ),
);
